import CityPageTemplate from "../city-template/CityPageTemplate";
import { wellsConfig } from "./data";

export default function WellsPage() {
  return <CityPageTemplate config={wellsConfig} />;
}